import { type VFC, useMemo } from 'react';
import { Dropdown, Popconfirm } from 'antd';
import type { MenuProps } from 'antd';
import { Icon } from '@/components/icon';

interface ActionButtonProps {
  onClick: () => void;
  onDelete: () => void;
  isLoading: boolean;
}

export const PersonsActionButton: VFC<ActionButtonProps> = ({ onClick, onDelete, isLoading }) => {
  const menu: MenuProps = useMemo(
    () => ({
      items: [
        {
          key: 'delete',
          danger: true,
          icon: <Icon iconString="delete" />,
          label: (
            <Popconfirm
              cancelText="Cancel"
              okText="Confirm"
              okType="danger"
              title="Do you want to delete this item? This action is irreversible."
              zIndex={99999}
              onConfirm={onDelete}
            >
              Delete
            </Popconfirm>
          ),
        },
      ],
    }),
    [onDelete],
  );

  return (
    <Dropdown.Button loading={isLoading} menu={menu} onClick={onClick}>
      Edit
    </Dropdown.Button>
  );
};
